interface ErrorResponse {
    code: number;
    message: string;
}

export interface DiditInitState {
    diditInitData: any;
    loading: boolean;
    diditInitError: ErrorResponse | null;
}


export enum DiditInitActionTypes {
    POST_DIDIT_INIT_DATA = "POST_DIDIT_INIT_DATA",
    POST_DIDIT_INIT_DATA_SUCCESS = "POST_DIDIT_INIT_DATA_SUCCESS",
    POST_DIDIT_INIT_DATA_ERROR = "POST_DIDIT_INIT_DATA_ERROR",
}

export type DiditInitCreateAction =
    | { type: DiditInitActionTypes.POST_DIDIT_INIT_DATA }
    | { type: DiditInitActionTypes.POST_DIDIT_INIT_DATA_SUCCESS; payload: any[] }
    | { type: DiditInitActionTypes.POST_DIDIT_INIT_DATA_ERROR; payload: any };